import React from 'react';
import { IUrlLinkItem } from '../../../ui';
import {
	Footer,
	IFooterLinkSection,
	IFooterLinkSections,
} from '../../shared/layout/footer';
import { IFooterAppLinksProps } from '../../shared/layout/footer/FooterAppLinks';
import { IFooterFinePrintProps } from '../../shared/layout/footer/FooterFinePrint';
import {
	IFooterSocialLinksProps,
	ISocialLinkItemPlatform,
} from '../../shared/layout/footer/FooterSocialLinks';
import { IFooterButtonSectionProps } from '../../shared/layout/footer/FooterButtonSection';

let linkCounter = 0;

const createLinkKey = () => {
	linkCounter += 1;
	return `link-${linkCounter}`;
};

const link: IUrlLinkItem = {
	get key() {
		return createLinkKey();
	},
	type: 'external-link',
	title: 'Link',
	url: 'https://www.google.com',
};

const linkSection: IFooterLinkSection = {
	get key() {
		return createLinkKey();
	},
	title: 'Link section',
	links: [link, link, link, link, link, link],
};

const linkSections: IFooterLinkSections = [
	linkSection,
	linkSection,
	linkSection,
];

const appLinks: IFooterAppLinksProps = {
	title: 'Download the CLT app',
	appStore: 'https://www.apple.com',
	playStore: 'https://www.google.com',
};

const socialLinks: IFooterSocialLinksProps = {
	title: 'Follow us',
	links: [
		{
			url: 'https://www.facebook.com',
			platform: ISocialLinkItemPlatform.Facebook,
		},
		{
			url: 'https://www.instagram.com',
			platform: ISocialLinkItemPlatform.Instagram,
		},
		{
			url: 'https://www.twitter.com',
			platform: ISocialLinkItemPlatform.Twitter,
		},
		{
			url: 'https://www.youtube.com',
			platform: ISocialLinkItemPlatform.YouTube,
		},
	],
};

const buttons: IFooterButtonSectionProps = {
	title: 'Stay up to date',
	buttons: [
		{
			title: 'Sign up for newsletter',
			link: 'https://example.com',
		},
		{
			title: 'Careers at CLT',
			link: 'https://careers.example.com',
		},
	],
};

const finePrint: IFooterFinePrintProps = {
	links: [
		{
			get key() {
				return createLinkKey();
			},
			type: 'internal-link',
			title: 'Privacy',
			url: '#',
		},
		{
			get key() {
				return createLinkKey();
			},
			type: 'internal-link',
			title: 'Disclaimer',
			url: '#',
		},
		{
			get key() {
				return createLinkKey();
			},
			type: 'internal-link',
			title: 'Terms & conditions',
			url: '#',
		},
		{
			get key() {
				return createLinkKey();
			},
			type: 'internal-link',
			title: 'Cookie policy',
			url: '#',
		},
	],
};

export const Footers = () => (
	<Footer
		linkSections={linkSections}
		appLinks={appLinks}
		socialLinks={socialLinks}
		buttonSection={buttons}
		finePrint={finePrint}
	/>
);
